export enum DocumentTypes {
  QUOTATION_FILE = "quotation_file",
  PROGRAM = "program",
  SIGN_IN_SHEET = "sign_in_sheet",
  HABILITATION_CERTIFICATE = "habilitation_certificate",
  PARTICIPATION_CERTIFICATE = "participation_certificate",
  ACHIEVEMENT_CERTIFICATE = "achievement_certificate",
  CONNEXION_LOGS = "connexion_logs",
  INVOICE = "invoice",
  GRANT_APPLICATION = "grant_application",
  OTHER = "other",
  PARTNER_PARTICIPATION_PROOF = "partner_participation_proof",
  CONVOCATION = "convocation",
  COMPLETION_CERTIFICATE = "completion_certificate",
  ABSENCE_JUSTIFICATION = "absence_justification",
  EXPENSE = "expense",
  TRAINING_SUPPORT = "training_support",
  SATISFACTION_SURVEY = "satisfaction_survey",
  CONVENTION = "convention",
}

/** What `/link` makes of the partner-mail link it was opened with (AC-ENVOI.31). */
export enum DocumentLinkStateEnum {
  LOADING = "loading",
  VALID = "valid",
  EXPIRED = "expired",
  NOT_FOUND = "not_found",
}

/** The orders route a partner-mail link wraps in its `document_link`. */
export enum DocumentLinkKindEnum {
  /** `/session-notifications/download-attendee-list?id=`: the snapshot, for 7 days after the send. */
  ATTENDEE_LIST = "attendee_list",
  /** `/documents/getSignedUrlFromProtectedLink?token=`: a session document, while its JWT is valid. */
  DOCUMENT = "document",
}
